import { useMemo } from 'react';
import { flow } from 'fp-ts/lib/function';
import { CompleteQuery } from 'modules/queryBuilder/types';
import { useConvertCatalogCondition } from './useConvertCatalogCondition';

/** updates query to append catalog data as a value in the condition */
export const useUpdateQueryWithCatalog = (query?: CompleteQuery): CompleteQuery | undefined => {
  const convertCatalogCondition = useConvertCatalogCondition();

  return useMemo(
    () =>
      query
        ? {
            ...query,
            searchQueries: query.searchQueries.map((criteria) => ({
              ...criteria,
              searchQueries: criteria.searchQueries.map((requirement) => ({
                ...requirement,
                searchCombo: {
                  ...requirement.searchCombo,
                  searchQueries: requirement.searchCombo.searchQueries.map(
                    flow(convertCatalogCondition),
                  ),
                },
              })),
            })),
          }
        : undefined,
    [query],
  );
};
